// DatePickerComponent.jsx
import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(utc);
dayjs.extend(timezone);

const RHFDateTimePicker = ({ name, ...props }) => {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      defaultValue={null}
      render={({ field: { onChange,value }, fieldState: { error } }) => {
        
        // Convert UTC value to local timezone (IST)
        const localDate = value ? dayjs.utc(value).tz("Asia/Kolkata") : null;

        return (
          <DateTimePicker
            value={localDate}
            onChange={(date) => {
                onChange(date ? dayjs(date).tz("Asia/Kolkata") : null);
              }}
              
            format="DD-MM-YYYY hh:mm A" // 12-hour format with AM/PM
            slotProps={{
              textField: {
                fullWidth: true,
                variant: 'outlined',
                error: !!error,
                helperText: error?.message,
                style: { height: '40px' },
              },
            }}
            {...props}
          />
        );
      }}
    />
  );
};

export default React.memo(RHFDateTimePicker);
